import React, { ChangeEvent } from 'react';
import { WrapperEntitySelector, TextInput } from '@components/Inputs';
import WithAllPropsApp from '@utils/wrappers/WithAllPropsApp';
import { IMinAppProps } from '@interfaces/App.interface';
import { CEntity, IOrganization } from '@ts/ui-models';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { Grid, useCheckPreview } from '@ts/storybook';

interface IdentityProviderStep2Props extends IMinAppProps {
  formData: IOrganization;
  setFormData: (attr: string) => (event: ChangeEvent | null, value: string | number | null) => void;
  requiredFields: string[];
  isPreview?: boolean;
}

const IdentityProviderStep2: React.FC<IdentityProviderStep2Props> = props => {
  const previewContent = useCheckPreview<IOrganization>(props.formData, ['identityProviderId', 'tenantId'], props.isPreview);

  if (previewContent) {
    return previewContent;
  }

  return (
    <Grid container spacing={2} p={2}>
      <Grid size={{ xs: 12 }}>
        <WrapperEntitySelector
          label={'Identity provider'}
          searchComponent={generateSearchEntitySelector('identityProvider')}
          value={props.formData.identityProvider ?? props.formData.identityProviderId}
          onChangeEntity={entity => props.setFormData('identityProviderId')(null, (entity as CEntity<any>)?.getID())}
          isReadOnly={props.isPreview}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <TextInput
          label="Tenant ID"
          value={props.formData.tenantId}
          required={props.requiredFields.includes('tenantId')}
          onChange={props.setFormData('tenantId')}
          isReadOnly={props.isPreview}
        />
      </Grid>
    </Grid>
  );
};
export default WithAllPropsApp(IdentityProviderStep2);
